import React, { useMemo } from "react";
import { useViewport } from "@bookingcom/bui-react";
import SearchTabs from "../../SearchTabs/index.js";
import { SkeletonFlightCard } from "../SkeletonFlightCard.js";
import { SearchLoadingMessage } from "../../SearchLoadingMessage/index.js";
import Frame from "../../Frame/index.js";
import useRouteName from "../../../../hooks/useRouteName.js";
import styles from "./SkeletonSearchDesktop.module.css";
import { useSplitBoundsCondition } from "../../../../utils/experiments/funnel/flights_split_bounds_us.js";
import flights_funnel_chip_sorting_desktop, { useTrackChipSortingDesktop } from "../../../../utils/experiments/funnel/flights_funnel_chip_sorting_desktop.js";
import SkeletonSearchSidebarDesktop from "./SkeletonSearchSidebar.desktop.js";
export const SkeletonSearchContent = ({ count = 4 }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(SearchLoadingMessage, null),
        Array.from({ length: count }).map((_, i) => (React.createElement(Frame, { key: i, mt: 3, mb: 3 },
            React.createElement(SkeletonFlightCard, null))))));
};
const SkeletonSearchDesktop = () => {
    const routeName = useRouteName();
    const { isLarge } = useViewport();
    const className = useMemo(() => (routeName.includes("flightdetails") ? styles.blur : ""), [routeName]);
    const { isSplitBounds } = useSplitBoundsCondition();
    useTrackChipSortingDesktop();
    return (React.createElement(Frame, { direction: "row", className: className },
        React.createElement(SkeletonSearchSidebarDesktop, null),
        React.createElement(Frame, { grow: 1, pb: 0, pl: isLarge ? 6 : 0 },
            isSplitBounds || flights_funnel_chip_sorting_desktop.trackWithDefaultStage() ? undefined : (React.createElement(SearchTabs, { showBestRankingInfo: true, fill: true })),
            React.createElement(SkeletonSearchContent, null))));
};
export default SkeletonSearchDesktop;
